import { CardDiv } from "./style"
import photo from "../../Assets/pedro.png"
import Typed from "react-typed"
import { useHistory } from "react-router-dom"

const Card = ({path,button}) =>{
    const history = useHistory()
    return(
        <>
            <CardDiv>
                <div>
                    <h1>Pedro Henrique</h1>
                    <Typed
                        strings={['Desenvolvedor Front-end', 'Bem-vindo(a)']}
                        typeSpeed={80}
                        backSpeed={80}
                        loop
                    />
                    <section></section>
                    <button onClick={()=> history.push(path)}>{button}</button>
                </div>
                <img src={photo}/>
               
            </CardDiv>
        </>
    )
}

export default Card